import { render, staticRenderFns } from "./ImageView.vue?vue&type=template&id=61399e3c&scoped=true"
import script from "./ImageView.vue?vue&type=script&lang=js"
export * from "./ImageView.vue?vue&type=script&lang=js"
import style0 from "./ImageView.vue?vue&type=style&index=0&id=61399e3c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61399e3c",
  null
  
)

export default component.exports